// GAVION deal amount visibility (supabase/schemas/72_gavion_deal_amount_visibility.sql): deals_visible sends amount
// null and amount_hidden true to a Setter / Apporteur only.
export type AmountRow = {
  amount?: number | null;
  amount_hidden?: boolean | null;
  /** GAVION deal package (76_): with a package the amount is the MRR per month (« /mois »). */
  proposed_package_id?: unknown;
};

/** The amount is a monthly value (the deal carries a « Forfait proposé », 76_). */
export const isMonthlyAmount = (deal: AmountRow | null | undefined): boolean =>
  deal?.amount_hidden !== true && deal?.proposed_package_id != null;

export const isAmountHidden = (deal: AmountRow | null | undefined): boolean =>
  deal?.amount_hidden === true;

/** How many rows of a list have their amount hidden (the totals leave them out). */
export const hiddenAmountCount = (
  deals: readonly (AmountRow | null | undefined)[],
): number => deals.filter(isAmountHidden).length;
